// extracted by mini-css-extract-plugin
export var border = "_w-7";
export var brand = "_w-s";
export var button = "_w-k";
export var center = "_w-9";
export var centered = "_w-5";
export var closeButton = "_w-b";
export var disabledWrapper = "_w-l";
export var error = "_w-o";
export var extraLarge = "_w-4";
export var extraSmall = "_w-1";
export var fill = "_w-h";
export var footer = "_w-g";
export var footerAction = "_w-i";
export var footerButtons = "_w-j";
export var header = "_w-6";
export var headerWithClose = "_w-c";
export var icon = "_w-n";
export var info = "_w-r";
export var inline = "_w-8";
export var large = "_w-3";
export var main = "_w-d";
export var modal = "_w-0";
export var neutral = "_w-t";
export var noPadding = "_w-f";
export var none = "_w-u";
export var scrollable = "_w-e";
export var small = "_w-2";
export var success = "_w-q";
export var tight = "_w-m";
export var titleIcon = "_w-a";
export var warn = "_w-p";